import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import PropertyDetail from './pages/PropertyDetail';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import Footer from './components/layout/Footer';
import Privacy from './pages/Privacy';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<PropertyDetail />} />
            <Route path="/galerie" element={<Gallery />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </main>
        <Footer />
    </div>
    </Router>
  );
}

export default App;
